import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Container,
  TextField
} from "@mui/material";
import Logo from "./assets/logo2.png";
import swal from "sweetalert";
import { useNavigate, useLocation } from "react-router-dom";

const OtpVerify = () => {
  const navigate = useNavigate();
   const location = useLocation();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputsRef = useRef([]);

const email1 =
  location.state?.email ||
  sessionStorage.getItem("email");

   const { email, expiresAt } = location.state || {};
const [timeLeft, setTimeLeft] = useState(null);
const [loadingResend, setLoadingResend] = useState(false);
// const [showExpiredMsg, setShowExpiredMsg] = useState(false);

// useEffect(() => {
//   if (timeLeft === 0) {
//     setShowExpiredMsg(true);

//     const timer = setTimeout(() => {
//       setShowExpiredMsg(false);
//     }, 3000); // 3 seconds

//     return () => clearTimeout(timer);
//   }
// }, [timeLeft]);


useEffect(() => {
  if (!expiresAt) return;

  const expiryTime = new Date(expiresAt).getTime();

  const timer = setInterval(() => {
    const remaining = Math.floor((expiryTime - Date.now()) / 1000);

    if (remaining <= 0) {
      clearInterval(timer);
      setTimeLeft(0);
    } else {
      setTimeLeft(remaining);
    }
  }, 1000);

  return () => clearInterval(timer);
}, [expiresAt]);


const handleResendOtp = async () => {
  if (!email) return;

  setLoadingResend(true);

  try {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/savyandsons/auth/signin`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      }
    );

    const data = await response.json();

    if (response.ok) {
      swal("OTP resent successfully");

      navigate("/signin-otp", {
        state: {
          email: data.email,
          expiresAt: data.expiresAt
        }
      });
    } else {
      swal(data.message || "Unable to resend OTP");
    }
  } catch (err) {
    swal("Server error");
  } finally {
    setLoadingResend(false);
  }
};


const formatTime = (seconds) => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
};


     if (!email) {
    navigate("/signin");
    return null;
  }
 const handleChange = (value, index) => {
  // Allow only digits
  if (!/^\d*$/.test(value)) return;

  const newOtp = [...otp];

  // ✅ Handle paste (multiple digits)
  if (value.length > 1) {
    const pasted = value.slice(0, 6).split("");

    pasted.forEach((digit, i) => {
      if (index + i < 6) {
        newOtp[index + i] = digit;
      }
    });

    setOtp(newOtp);

    const nextIndex = Math.min(index + pasted.length, 5);
    inputsRef.current[nextIndex]?.focus();
    return;
  }

  // ✅ Normal single digit entry
  newOtp[index] = value;
  setOtp(newOtp);

  if (value && index < 5) {
    inputsRef.current[index + 1]?.focus();
  }
};


  const handleKeyDown = (e, index) => {
  if (e.key === "Backspace") {
    e.preventDefault();

    const newOtp = [...otp];

    if (newOtp[index]) {
      // Clear current box
      newOtp[index] = "";
      setOtp(newOtp);
    } else if (index > 0) {
      // Move back and clear previous
      newOtp[index - 1] = "";
      setOtp(newOtp);
      inputsRef.current[index - 1]?.focus();
    }
  }
};


 const handleVerify = async () => {
  const otpValue = otp.join("");

if (timeLeft === 0) {
  swal("OTP expired. Please resend OTP.");
  return;
}

  if (otpValue.length !== 6) {
    swal("Please enter a valid 6-digit OTP");
    return;
  }

  const email =
    location.state?.email ||
    sessionStorage.getItem("email");

  if (!email) {
    swal("Session expired. Please sign in again.");
    navigate("/signin");
    return;
  }

  try {
     
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/savyandsons/auth/verify-otp`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          otp: otpValue,
          
        })
      }
    );

    const data = await response.json();

    if (response.ok) {
      sessionStorage.setItem("user", JSON.stringify(data));
      sessionStorage.setItem("accessToken", data.accessToken);

        sessionStorage.setItem("roles", JSON.stringify(data.roles));
                    sessionStorage.setItem("userId", JSON.stringify(data.id));
                    sessionStorage.setItem("userName", JSON.stringify(data.username));
                     sessionStorage.setItem("email", JSON.stringify(data.email));
                  
      navigate("/dashboard");
    } else {
      swal(data.message || "Invalid or expired OTP");
    }

  } catch (err) {
    console.error(err);
    swal("Server error");
  }
};


  return (
    <Container
      maxWidth="md"
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 4,
          width: "100%",
          maxWidth: 420,
          textAlign: "center",
          borderRadius: 3,
          background: `
            linear-gradient(
              180deg,
              rgba(255,205,120,0.30) 0%,
              rgba(255,255,255,0.92) 55%,
              rgba(0,0,0,0.06) 100%
            )
          `,
          border: "1px solid rgba(0,0,0,0.08)",
          boxShadow:
            "0 24px 60px rgba(0,0,0,0.18), 0 6px 14px rgba(0,0,0,0.08)"
        }}
      >
        {/* LOGO */}
        <Box mb={2}>
          <img
            src={Logo}
            alt="Logo"
            style={{ width: "70%", maxWidth: 220 }}
          />
        </Box>

        {/* TEXT */}
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: "#1E2548" }}
          gutterBottom
        >
          OTP Verification
        </Typography>

        <Typography
          variant="body2"
          sx={{ color: "#555", mb: 3 }}
        >
          Enter the 6-digit code sent to your email <br/>
          {email}
        </Typography>

        {/* OTP INPUTS */}
        <Box
          display="flex"
          justifyContent="space-between"
          gap={1.2}
          mb={3}
        >
          {otp.map((digit, index) => (
         <TextField
  key={index}
  inputRef={(el) => (inputsRef.current[index] = el)}
  value={digit}
  onChange={(e) => handleChange(e.target.value, index)}
  onKeyDown={(e) => handleKeyDown(e, index)}
  onPaste={(e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text");
    handleChange(pasted, index);
  }}
  inputProps={{
    maxLength: 6,
    inputMode: "numeric",
    style: {
      textAlign: "center",
      fontSize: 20,
      fontWeight: 600
    }
  }}
  sx={{
    width: 48,
    "& .MuiOutlinedInput-root": {
      borderRadius: 2
    }
  }}
/>

          ))}
        </Box>
<Typography variant="body2" sx={{ color: "red", mb: 2 }}>
  {timeLeft === null
    ? ""
    : timeLeft > 0
      ? `OTP expires in ${formatTime(timeLeft)}`
      : "OTP expired"}
</Typography>


{timeLeft === 0 && (
  <Button
  fullWidth
  variant="outlined"
  onClick={handleResendOtp}
  disabled={loadingResend}
  sx={{
    mb: 2,
    py: 1.1,
    fontWeight: 700,
    textTransform: "none",
    borderRadius: 2,

    // 🌤 Light logo color (default)
    color: "#E5B100",
    borderColor: "#E5B100",
    backgroundColor: "rgba(229, 177, 0, 0.08)",

    // 🌑 Dark logo color on hover
    "&:hover": {
      color: "#B58A00",
      borderColor: "#B58A00",
      backgroundColor: "rgba(181, 138, 0, 0.18)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.25)"
    },

    // 🚫 Disabled state
    "&:disabled": {
      color: "#CFCFCF",
      borderColor: "#E0E0E0",
      backgroundColor: "transparent"
    }
  }}
>
  {loadingResend ? "Resending..." : "Resend OTP"}
</Button>

)}

        {/* VERIFY BUTTON */}
        <Button
          fullWidth
          onClick={handleVerify}
          sx={{
            py: 1.2,
            fontWeight: 700,
            textTransform: "none",
            borderRadius: 2,
            background: "linear-gradient(135deg, #0d0d0f, #1a1a1d)",
            color: "#fff",
            boxShadow: "0 8px 18px rgba(0,0,0,0.35)",
            "&:hover": {
              background: "linear-gradient(135deg, #17171a, #000000)",
              boxShadow: "0 10px 24px rgba(0,0,0,0.45)",
              transform: "translateY(-1px)"
            }
          }}
        >
          Verify OTP
        </Button>
      </Paper>
    </Container>
  );
};

export default OtpVerify;
